import React from 'react';

import { useFacetsContext } from 'components/search/Facets/FacetsProvider';
import { FacetAccordion } from 'components/search/FacetAccordion/FacetAccordion';
import useMartyContext from 'hooks/useMartyContext';

export const FacetsSidebar = () => {
  const { testId } = useMartyContext();

  const {
    state: { facets, autoComplete },
    actions: { handleFacetSelect, handleAccordionChange, trackFacetSearch },
    meta: { hasAutoComplete, navigationVersion }
  } = useFacetsContext();

  const expandedValues = facets.filter(facet => facet.isExpanded).map(facet => facet.facetField);

  return (
    <FacetAccordion.Root type="multiple" value={expandedValues} onValueChange={handleAccordionChange} className="max-md:px-2">
      {facets.map((facet, facetIndex) => {
        const { facetField, facetFieldDisplayName, values } = facet;

        return (
          <FacetAccordion.Item key={facetField} value={facetField} data-test-id={testId('facetGroup')} facet={facet} context="desktop">
            <FacetAccordion.Trigger id={facetField} data-test-id-facet-head-name={facetFieldDisplayName}>
              <FacetAccordion.DisplayName data-test-id={testId('facetGroupHeadTestId')} />
              <FacetAccordion.SelectedValueNames data-test-id={testId('facetSelectedValues')} />
            </FacetAccordion.Trigger>

            <FacetAccordion.Content>
              {hasAutoComplete && <FacetAccordion.AutoComplete onChange={e => trackFacetSearch(facet, e.target.value)} />}

              <FacetAccordion.ValueList
                data-test-id={testId(`${facetFieldDisplayName}-values`)}
                autoComplete={autoComplete}
                navigationVersion={navigationVersion}
              >
                {({ facetValue }) => (
                  <FacetAccordion.Value
                    data-test-id={testId(`facet-${facetValue.name}`)}
                    facetValue={facetValue}
                    onFacetSelect={() => {
                      const valueIndex = values.findIndex(value => value.name === facetValue.name);

                      handleFacetSelect({
                        facetGroup: facetField,
                        facetName: facetValue.name,
                        selectedFacetGroupIndex: facetIndex,
                        selectedFacetIndex: valueIndex,
                        isSelected: facetValue?.selected || false,
                        facetValue
                      });
                    }}
                  />
                )}
              </FacetAccordion.ValueList>
            </FacetAccordion.Content>
          </FacetAccordion.Item>
        );
      })}
    </FacetAccordion.Root>
  );
};
